Vendd.Scripts.load(function () {

    if ($('.homepage-slider > ul > li').length < 2)
        return;

    const hpMainSlider = new Swiper(".home-page .homepage-slider", {
        slidesPerView: 1,
        autoHeight: true,
        rewind: true,
        fadeEffect: {
            crossFade: true
        },
        effect: 'fade',
        watchSlidesProgress: true,
        keyboard: { enabled: true },
        speed: 1000,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '">' + $('.home-page .homepage-slider .swiper-slide').eq(index).attr("data-pager") + '</span>';
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    hpMainSlider.on('slideChange', function () {
        var $currentSlide = $(".homepage-slider > ul > li[data-index='" + this.previousIndex + "']");
        var hasVideo = $('.video-slide', $currentSlide).length > 0;
        var videoInitialized = $('iframe', $currentSlide).length > 0;

        if (hasVideo && videoInitialized) {
            var YTvideo = YT.get($('iframe', $currentSlide).attr('id'));
            //pause video
            YTvideo.pauseVideo();
        }
    });

});
